module.exports = "<ul *ngIf=\"totalPages() > 1\" class=\"pagination pagination-sm no-margin pull-right\">\n  <li *ngIf=\"page != 1\"><a (click)=\"pageClicked(prevPage())\">«</a></li>\n  <li *ngFor=\"let p of pagesRange()\"><a (click)=\"pageClicked(p)\">{{p}}</a></li>\n  <li *ngIf=\"totalPages() > page\"><a (click)=\"pageClicked(nextPage())\">»</a></li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/pagination/pagination.component.html
// module id = ./src/app/common/pagination/pagination.component.html
// module chunks = main